import { makeStyles } from '@material-ui/core';

export default makeStyles(theme => ({
  header: {
    marginBottom: theme.spacing(4),
    fontSize: 16,
    [theme.breakpoints.up('mobile')]: {
      fontSize: 24,
    },
  },
  container: {
    borderRadius: 8,
    padding: theme.spacing(2),
    border: [1, 'solid', theme.palette.colors.border],
  },
  choosePlan: {
    marginBottom: theme.spacing(2),
  },
  subscriptions: {
    display: 'flex',
  },
  plans: {
    display: 'flex',
  },
  planControlBar: {
    marginTop: theme.spacing(1),
    display: 'flex',
    alignItems: 'center',
  },
  planItem: {
    marginRight: theme.spacing(2),
  },
  radioButton: {
    padding: 0,
    marginRight: theme.spacing(1),
  },
  saveButton: {
    marginTop: theme.spacing(2),
    width: '100%',
  },
}));



// WEBPACK FOOTER //
// ./src/components/LoanOfficerSettings/components/SubscriptionPage/components/SubscriptionInfo/useStyles.js